module.exports = __webpack_public_path__ + "img/wode.42260cc8.png";